import { createContext } from "react";

/**
 * Page filters as sent to the back with the charts of the page
 * Value: { filters, definitions, language, displayDates }
 * null when the widgets are not displayed in a charts page (no filters button is displayed then)
 */
const ChartFiltersContext = createContext(null);

export default ChartFiltersContext;
